export default __webpack_public_path__ + "static/media/erlang.85ff75a9.svg";